import { SafeArea } from "@capacitor-community/safe-area";

export const configSafeArea = () => {
  SafeArea.enable({
    config: {
      customColorsForSystemBars: true,
      statusBarColor: "#00000000", // transparent
      statusBarContent: "light",
      navigationBarColor: "#00000000", // transparent
      navigationBarContent: "light",
    },
  });
};
